import React from "react";
import "./App.css";
import Landing from "./views/Landing";
import { StyleProvider } from "./context/StyleContext";
import { LanguageProvider } from "./context/LanguageContext";
import { TimmaProvider } from "./context/TimmaContext";

import { createBrowserRouter, RouterProvider } from "react-router-dom";
const router = createBrowserRouter([
  {
    path: "/",
    element: <Landing />,
  },
]);

function App() {
  return (
    <LanguageProvider>
      <TimmaProvider>
        <StyleProvider>
          <AppRoutes />
        </StyleProvider>
      </TimmaProvider>
    </LanguageProvider>
  );
}

export default App;

const AppRoutes = ({ children }: { children?: React.ReactNode }) => {
  return (
    <React.StrictMode>
      <RouterProvider router={router}>{children}</RouterProvider>
    </React.StrictMode>
  );
};
